import { render } from "./PositionTable.vue?vue&type=template&id=6df74402&ts=true"
import script from "./PositionTable.vue?vue&type=script&lang=ts"
export * from "./PositionTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__